module.exports = __webpack_public_path__ + "static/media/comment-alt-music.e1e1ae9f.svg";